import styled from '@emotion/styled'
import React, { useCallback } from 'react'
import { useToastForReactQuery, useVisible } from '../../../../utils/custom-hooks'
import Button from '../../../components/common/Button'
import DialogExportTransactionFilter, {
  ExportTransactionFilterFormValues,
} from './DialogExportTransactionFilter'
import 'react-toastify/dist/ReactToastify.css'
import ConfirmCard from '../../../components/common/Card'
import { useExportTransactionReport } from '../../../services/transaction/transaction-query'
import { ExportTransactionReportParams } from '../../../services/transaction/transaction-typed'
import { Box, makeStyles, Modal } from '@material-ui/core'
import Text from '../../../components/common/Text'
import { useGetTotalAccumulate } from '../../../services/payment/payment-query'
import { Authorize } from '../../../components/Authorize'
import { ROLE } from '../../../services/user/user-typed'

const Layout = styled.div`
  display: flex;
  flex: 1;
  flex-flow: row;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  padding-right: 16px;
`
const ButtonStyled = styled(Button)`
  padding: 7px 13px;
`

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

const TransactionButton = () => {
  const { visible, open, close } = useVisible()
  const onShowTotalAccumulate = useVisible()
  const classes = useStyles()
  const { data: totalAccumulate } = useGetTotalAccumulate(onShowTotalAccumulate.visible)

  const { mutate: exportTransactionReport } = useExportTransactionReport()
  const toast = useToastForReactQuery()

  const onExportClick = useCallback(
    (values: ExportTransactionFilterFormValues) => {
      const { filterRange, status, type } = values
      const { endDate, startDate } = filterRange || {}
      if (startDate && endDate) {
        const params: ExportTransactionReportParams = {
          startDate,
          endDate,
          status: status?.value ? status?.value : undefined,
          type: type?.value ? type?.value : undefined,
        }

        const toastId = toast.open('Exporting...')
        exportTransactionReport(params, {
          onSuccess: () => {
            toast.onSuccess(toastId)
          },
          onError: error => {
            toast.onError(toastId, error)
          },
        })
      }
      close()
    },
    [close, toast, exportTransactionReport],
  )
  const onClose = useCallback(() => {
    close()
  }, [close])

  return (
    <Layout>
      <Authorize role={ROLE.SUPER_ADMIN}>
        <ButtonStyled variant="warning" onClick={() => onShowTotalAccumulate.open()}>
          Total Accumulate
        </ButtonStyled>
      </Authorize>

      <Box width={8} />
      <ButtonStyled variant="warning" onClick={open}>
        Export
      </ButtonStyled>
      <DialogExportTransactionFilter visible={visible} onClose={onClose} onSubmit={onExportClick} />
      <Modal
        className={classes.modal}
        open={onShowTotalAccumulate.visible}
        onClose={onShowTotalAccumulate.close}
      >
        <ConfirmCard
          style={{
            display: 'flex',
            width: '300px',
            textAlign: 'center',
          }}
        >
          <Text bold>Total Accumulate</Text>
          <Text>{totalAccumulate?.toLocaleString()}</Text>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              paddingTop: '10px',
            }}
          >
            <Button onClick={() => onShowTotalAccumulate.close()}>Ok</Button>
          </div>
        </ConfirmCard>
      </Modal>
    </Layout>
  )
}

export default TransactionButton
